import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { ActivatedRoute, ParamMap, Router } from '@angular/router';
import { CompanyVendor, ExemptVendor, Vendor } from 'src/app/classes/models';
import { GridActionColumnActions } from 'src/app/interfaces/grid-action-column-actions';
import { GridActionColumnMap } from 'src/app/interfaces/grid-action-column-map';
import { AuthService } from 'src/app/services/auth.service';
import { CompanyVendorService } from 'src/app/services/company-vendor.service';

@Component({
  selector: 'app-client-my-vendors-contracts',
  templateUrl: './client-my-vendor-contracts.component.html',
  styleUrls: ['./client-my-vendor-contracts.component.less'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class ClientMyVendorContractsComponent implements OnInit {
  constructor(
    private route: ActivatedRoute,
    private Router: Router,
    private AuthService: AuthService
  ) {}

  Vendor!: Vendor | ExemptVendor;

  suppliedGridQueryData: {
    [key: string]: any;
  } = {};

  ColumnIdToColumnActions: GridActionColumnMap = {
    ['$actionColumn']: ['view']
  };

  action({
    action,
    rowData
  }: {
    action: GridActionColumnActions;
    rowData: any;
  }) {
    if (action === 'view') {
      this.Router.navigate(['contract', rowData.id], {
        relativeTo: this.route
      });
    }
  }

  ngOnInit(): void {
    const paramMap: ParamMap = this.route.snapshot.paramMap;
    const VendorId = Number(paramMap.get('VendorId')) || null;
    const ExemptVendorId = Number(paramMap.get('ExemptVendorId')) || null;
    const CompanyId = this.AuthService.getUserCompanyId();

    Object.assign(this.suppliedGridQueryData, {
      Site: JSON.stringify({
        options: {
          required: true
        },
        CompanyId
      })
    });

    if (VendorId) {
      Object.assign(this.suppliedGridQueryData, { VendorId });
    }

    if (ExemptVendorId) {
      Object.assign(this.suppliedGridQueryData, { ExemptVendorId });
    }
  }
}
